import type { ChannelMacros } from '@melodinai/types';

/** Pure mapping reference — engine applies the same relationships in sslApplyMacros. */
export function macrosToHints(m: ChannelMacros): string[] {
  const hints: string[] = [];
  if (m.punch > 0.15) hints.push('Compression + transient focus');
  if (m.weight > 0.15) hints.push('Low shelf + saturation');
  if (m.air > 0.15) hints.push('High shelf air');
  if (m.width > 0.55) hints.push('Stereo widen');
  else if (m.width < 0.35) hints.push('Narrower stereo');
  return hints;
}

export const MACRO_LABELS: { key: keyof ChannelMacros; label: string; hint: string }[] = [
  { key: 'punch', label: 'Punch', hint: 'Compression + transients' },
  { key: 'weight', label: 'Weight', hint: 'Low-end + saturation' },
  { key: 'air', label: 'Air', hint: 'High-frequency lift' },
  { key: 'width', label: 'Width', hint: 'Stereo expansion' },
];
